import React from 'react';
import { Field, FormikProps } from 'formik';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { IAdHocTokenReport } from '../../../lib/types/communication.types';
import { VariablePanel } from '../VariablePanel/variable-panel.component';
import { SMS_BODY_MAX } from '../../../lib/helpers/sms.helpers';
import { IComposePanelFields } from './compose-panel.types';
import { InsertTarget } from './compose-panel.insert';
import { TokenHighlightField } from './token-highlight-field.component';
import { FieldTokenIssues } from './field-token-issues.component';
import { IFieldTokenMessage } from './compose-panel.validation';
import { messages } from './compose-panel.messages';
import { SmsCharacterCounter } from './sms-character-counter.component';
import { SectionDivider } from './compose-panel.styles';

interface IComposeSmsSectionProps {
  form: FormikProps<IComposePanelFields>;
  assessmentId: string;
  hasSessionContext: boolean;
  onFieldFocus: (target: InsertTarget) => void;
  onInsertVariable: (token: string) => void;
  isSubmitting: boolean;
  // Latest server token report — drives the in-field invalid-token highlight.
  tokenReport?: IAdHocTokenReport;
  // Live per-field issue messages for the SMS body (undefined = clean).
  smsIssues?: IFieldTokenMessage[];
}

export const ComposeSmsSection: React.FC<IComposeSmsSectionProps> = ({
  form,
  assessmentId,
  hasSessionContext,
  onFieldFocus,
  onInsertVariable,
  isSubmitting,
  tokenReport,
  smsIssues
}) => {
  const { values } = form;

  return (
    <>
      <SectionDivider />
      <VariablePanel
        sectionLabel={(
          <Typography variant="overline" color="textSecondary">
            <IntlMsg {...messages.smsSectionHeading} />
          </Typography>
        )}
        assessmentId={assessmentId}
        hasSessionContext={hasSessionContext}
        onInsert={onInsertVariable}
      />
      <Box mt={1}>
        <Field
          fid="cmps"
          name="smsBody"
          component={TokenHighlightField}
          multiline
          report={tokenReport}
          placeholder="Write your SMS message…"
          rows={5}
          maxLength={SMS_BODY_MAX}
          onFocus={() => onFieldFocus('smsBody')}
          disabled={isSubmitting}
        />
        <SmsCharacterCounter value={values.smsBody} />
        <FieldTokenIssues issues={smsIssues} />
      </Box>
    </>
  );
};
